module.exports = __webpack_public_path__ + "img/JC.80e5f784.png";